import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  FeatureFlagService,
  FeatureFlags,
} from '../../services/feature-flag.service';

@Injectable({ providedIn: 'root' })
export class TikTokShopEnabledGuard {
  constructor(
    private readonly router: Router,
    private readonly featureFlags: FeatureFlagService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    const dashboard = this.router.createUrlTree(['/dashboard']);
    return this.featureFlags.isEnabled(FeatureFlags.TIKTOK_SHOP_SCAN).pipe(
      map((enabled) => (enabled ? true : dashboard)),
      catchError(() => of(dashboard))
    );
  }
}
